import React from 'react';
import { ChevronRight } from 'lucide-react';
import { sanitizeOptimizationDescription } from '../../utils/sanitizeOptimizationDescription';

const CARD_DESCRIPTION_P_CLASS = 'text-sm text-white/70 leading-snug m-0';

const OptimizationCard = ({ optimization, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-6 shadow-lg hover:shadow-xl hover:bg-gradient-to-br hover:from-slate-700/90 hover:via-slate-800/90 hover:to-indigo-800/90 hover:border-white/30 hover:scale-[1.01] transition-all duration-500 ease-out cursor-pointer"
    >
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
              optimization.type === 'ESCALAR' ? 'bg-green-500/20 text-green-100 border border-green-400/30' :
              optimization.type === 'OPTIMIZAR' ? 'bg-blue-500/20 text-blue-100 border border-blue-400/30' :
              'bg-red-500/20 text-red-100 border border-red-400/30'
            }`}>
              {optimization.type}
            </span>
            <h3 className="text-lg font-bold text-white">
              {optimization.action}
            </h3>
          </div>
          <ChevronRight className="w-5 h-5 text-white/50" />
        </div>

        <div className="space-y-2 mb-4">
          <div className="text-sm text-white/80">
            <span className="font-semibold">Objetivo:</span> {optimization.objective_name}
          </div>
          <div className="text-sm text-white/80">
            <span className="font-semibold">Campaña:</span> {optimization.campaign_name}
          </div>
        </div>

        <div
          className="line-clamp-2"
          dangerouslySetInnerHTML={{
            __html: sanitizeOptimizationDescription(optimization?.description, {
              fallbackText: 'Optimización sugerida',
              pClassName: CARD_DESCRIPTION_P_CLASS,
            }),
          }}
        />
      </div>
    </div>
  );
};

export default OptimizationCard;

